module.exports = __webpack_public_path__ + "img/logo.6f96e87f.svg";